import React from 'react';
import { useTranslation } from 'react-i18next';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { ServicesBookingPayment } from '@components/templates';

export function ServicesBookingPaymentPage() {
    const { t } = useTranslation();

    const translations = {
        title: t('services-booking-payment-component.metatags.title'),
        description: t('services-booking-payment-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.servicesBookingPayment,
        index: false,
    });

    return <ServicesBookingPayment />;
}
